// Import GSAP core and the ScrollTrigger plugin
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

$(document).ready(function () {

    preloadImages();

    function preloadImages() {
        $('.js-crossfade li a, .js-crossfade li span').each(function() {
            var imgSrc = $(this).data('image');
            if (imgSrc) {
                var img = new Image();
                img.src = imgSrc;
                img.onload = function() {
                    $(this).closest('.js-crossfade').addClass('images-loaded');
                }
            }
        });
    }

    // Crossfade images on hover based on data-image attribute
    $('.js-crossfade li a,.js-crossfade li span').on('mouseenter', function () {
        var newImageSrc = $(this).data('image');

        var $currentBlock = $(this).closest('.js-crossfade');

        // Clear images in other blocks first
        $('.js-crossfade').not($currentBlock).each(function() {
            var $otherBlockImage = $(this).find('figure img');
            if ($otherBlockImage.length) {
                gsap.to($otherBlockImage, {
                    opacity: 0,
                    duration: 0.3,
                    ease: 'power1.inOut',
                    onComplete: function() {
                        $otherBlockImage.remove();
                    }
                });
            }
        });

        // Get the figure associated with the current .js-crossfade block
        var $blockImageContainer = $(this).closest('.js-crossfade').find('figure');
        var $currentImage = $blockImageContainer.find('img');

        // Check if the new image source exists
        if (newImageSrc) {
            // Create the new image element
            var $newImage = $('<img>', {
                src: newImageSrc,
                class: 'img-cover',
                css: {
                    // position: 'absolute',
                    // left: 0,
                    // width: '100%',
                    // height: 'auto',
                    opacity: 0,
                }
            });

            // Append the new image to the container
            $newImage.appendTo($blockImageContainer);

            // Create a GSAP timeline for sequential animation
            var tl = gsap.timeline();

            // Ensure the current image smoothly fades out to 0 opacity
            tl.to($currentImage, {
                opacity: 0,
                duration: 0.3,
                ease: 'power1.inOut',
                onComplete: function () {
                    $currentImage.remove();
                }
            });

            // Fade in the new image after the old one fades out
            tl.to($newImage, {
                opacity: 1,
                duration: 0.3,
                ease: 'power1.inOut',
            }, "-=0");
        }
    });
});
